import { deleteConfirmModal } from "@helpers/DeleteValidate";
import { errorHandler } from "@helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    CallWithFormDataFile,
    downloadBlob,
    objectToFormData,
} from "@helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "@redux/actions/administrador/ui/ui";
import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

const initialState = {
    active: null,
    activeItem: null,
    list: [],
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
};

export const AcademicEvents = createSlice({
    name: "AcademicEvents",
    initialState,
    reducers: {
        setActive: (state, action) => {
            state.active = action.payload;
        },
        clearActive: (state) => {
            state.active = initialState.active;
        },

        setActiveItem: (state, action) => {
            state.activeItem = action.payload;
        },
        clearActiveItem: (state) => {
            state.activeItem = initialState.activeItem;
        },

        setList: (state, action) => {
            state.list = action.payload;
        },
        clearList: (state) => {
            state.list = initialState.list;
        },

        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },

        clearState: (state) => {
            state = initialState;
        },
    },
});

export const {
    setActive,
    clearActive,

    setActiveItem,
    clearActiveItem,

    setList,
    clearList,

    setPagination,
    clearPagination,

    clearState,
} = AcademicEvents.actions;

export default AcademicEvents.reducer;

export const startCreate = (
    values,
    setErrors = () => {},
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await CallWithFormData(
            `operators/academic-events`,
            "POST",
            objectToFormData(values)
        );

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Evento académico creado.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 4000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startShow = ({
    query = "",
    page = 1,
    number_rows = 25,
    list = false,
    type = [],
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("q", query);
        params.set("page", page);
        params.set("per_page", number_rows);
        params.set("list", list ? 1 : 0);
        if (type.lenght > 0) {
            params.set("type", type.join(","));
        }

        const resp = await Call(
            `operators/academic-events`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (list) {
                dispatch(setList(resp.success));
            } else {
                dispatch(setPagination(resp.success));
            }
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdate = (
    id,
    values,
    setErrors = () => {},
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await CallWithFormData(
            `operators/academic-events/${id}`,
            "POST",
            objectToFormData(values)
        );

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Evento académico actualizado.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 4000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDelete = (id, callback = () => {}) => {
    return async (dispatch) => {
        deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `operators/academic-events/${id}`,
                "DELETE"
            );

            if (resp.success) {
                Swal.fire({
                    title: "Éxito",
                    text: "Evento académico eliminado.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 4000,
                });
                callback();
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};

//* CRUD para los items de eventos académicos

export const startCreateItem = (
    academicEventId,
    values,
    setErrors = () => {},
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/academic-events/items/${academicEventId}`,
            "POST",
            values
        );

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Elemento creado correctamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 4000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateItem = (
    itemId,
    values,
    setErrors = () => {},
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/academic-events/items/${itemId}`,
            "PATCH",
            values
        );

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Elemento actualizado correctamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 4000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDeleteItem = (activityId, callback = () => {}) => {
    return async (dispatch) => {
        deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `operators/academic-events/items/${activityId}`,
                "DELETE"
            );

            if (resp.success) {
                callback();
                Swal.fire({
                    title: "Éxito",
                    text: "Elemento eliminado correctamente.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 4000,
                });
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};

export const startGetItems = (eventId) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/academic-events/items/${eventId}`,
            "GET"
        );

        if (resp.success) {
            dispatch(setActive(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startGetItem = (academic_event_item_id) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/academic-events/items/get-by-id/${academic_event_item_id}`,
            "GET"
        );

        if (resp.success) {
            dispatch(setActiveItem(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSetItemTeachers = (
    academic_event_item_id,
    teacher_ids = []
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/academic-events/items/set-teachers/${academic_event_item_id}`,
            "PATCH",
            { teacher_ids }
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Docentes revisores del elemento actualizados correctamente.",
                icon: "success",
            });
            dispatch(setActiveItem(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSendReviewerCertificate = (
    values,
    setErrors = () => {},
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            "operators/academic-events/certificate/reviewer",
            "POST",
            values
        );

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Certificado enviado correctamente.",
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDownloadAcademicEventAttachments = (academic_event_id) => {
    return async (dispatch) => {
        // Mostrar alerta de advertencia antes de descargar
        const result = await Swal.fire({
            title: "Descarga de archivos",
            html: `Se descargará un ZIP con todos los archivos adjuntos de los expositores del evento.<br><br>
                   Esto podría tardar algunos minutos dependiendo del tamaño de los archivos.<br><br>
                   <strong>Por favor, no cierres la pestaña del navegador durante la operación.</strong>`,
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        if (!result.isConfirmed) return; // Si cancelan, no hacemos nada

        dispatch(startUILoading());

        const resp = await CallWithFormDataFile(
            "operators/academic-events/download-attachments/" +
                academic_event_id,
            "GET"
        );

        if (resp.error) {
            errorHandler(resp);
        } else {
            downloadBlob(resp, `archivos_adjuntos_${academic_event_id}.zip`);
        }

        dispatch(stopUILoading());
    };
};

export const startSendMassiveCertificates = (data, callback = () => {}) => {
    return async (dispatch) => {
        const { academic_event_id, event_participant_ids } = data;

        const result = await Swal.fire({
            title: "Confirmar envío masivo",
            html: `
                Está a punto de generar y enviar constancias para
                <strong>${event_participant_ids.length}</strong> participante${
                event_participant_ids.length > 1 ? "s" : ""
            }.<br><br>
                Este proceso puede tardar varios minutos dependiendo de la cantidad.
                <br><br>
                ¿Desea continuar?
            `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, continuar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            width: 500,
        });

        if (!result.isConfirmed) return; // Si cancela, no hace nada

        dispatch(startUILoading());

        const resp = await Call(
            `operators/academic-events/certificate/participant/massive/${academic_event_id}`,
            "POST",
            { event_participant_ids }
        );

        if (resp.success) {
            const { summary } = resp.success;
            const { success, failed, failed_list } = summary;

            // 🔹 Construir resumen HTML
            let htmlSummary = `
                <div style="text-align:start;">
                    <strong style="color:green;">Exitosos:</strong> ${success}<br>
                    <strong style="color:red;">Fallidos:</strong> ${failed}<br>
            `;

            if (failed_list.length > 0) {
                htmlSummary += `
                    <div style="margin-top:10px;">
                        <strong>Folios fallidos:</strong><br>
                        <span style="font-size:13px; color:gray;">
                            ${failed_list
                                .map(
                                    (folio) =>
                                        `<span style="white-space: nowrap;">${folio}</span>`
                                )
                                .join(", ")}
                        </span>
                    </div>
                `;
            }

            htmlSummary += `
                    <div style="margin-top:15px; font-size:14px; color:#444;">
                        <em>Los correos comenzarán a enviarse automáticamente en los próximos
                        <strong>10 minutos o menos</strong>.</em>
                    </div>
                </div>
            `;

            Swal.fire({
                icon: failed > 0 ? "warning" : "success",
                title:
                    failed > 0
                        ? "Proceso completado con algunos errores"
                        : "Certificados generados correctamente",
                html: htmlSummary,
                width: 700,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#2e4a6c",
            });

            callback();
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startSendCertificate = (participantId, callback = () => {}) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "Confirmar envío",
            html: `
                Está a punto de generar y enviar la constancia para este participante.
                <br><br>
                ¿Desea continuar?
            `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            width: 500,
        });

        if (!result.isConfirmed) return; // Si cancela, no hace nada

        dispatch(startUILoading());

        const resp = await Call(
            `operators/academic-events/certificate/participant/${participantId}`,
            "POST"
        );

        if (resp.success) {
            Swal.fire({
                icon: "success",
                title: "Constancia enviada",
                html: `
                    La constancia fue enviada exitosamente.<br>
                    <em>El participante la recibirá en 10 minutos o menos.</em>
                `,
                width: 500,
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#2e4a6c",
            });

            callback();
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
